export default "__VITE_ASSET__CdJi$SoZ__"